export default ".editable-column{border-bottom:1px #000 solid}";